<template>
  <action-type-template :type="'Destination'" :action="action" :items="items" grid="person3" />
</template>

<script>
import ActionTypeTemplate from './ActionTypeTemplate'

export default {
  name: 'SportFootballMatchActionDestination',
  components: { ActionTypeTemplate },
  props: {
    action: Object
  },
  computed: {
    items () {
      // Filter by type and remove particular case 'shot not on target' (id = 1)
      return this.$store.getters['Sport/Football/Action/Destination/list'].filter(
        (item) => { return item.typeId === this.action.typeId && item.id !== 1 }
      )
    }
  }
}
</script>
